import React from "react";
import { cn } from "@/lib/utils";

const CARDS = [
  { key: "requirements", label: "Requirements", suffix: "mapped", view: "board", tone: "" },
  { key: "unsupported", label: "Unsupported", view: "gaps", filter: "UNSUPPORTED_REQUIREMENT", tone: "danger" },
  { key: "contradicted", label: "Contradicted", view: "gaps", filter: "CONTRADICTED", tone: "danger" },
  { key: "awaitingVerification", label: "Awaiting Verification", view: "gaps", filter: "VERIFICATION", tone: "warning" },
  { key: "foundationIssues", label: "Exhibit / Foundation Issues", view: "gaps", filter: "FOUNDATION", tone: "warning" },
];

export function StatusStrip({ metrics, onPick }) {
  if (!metrics) return null;
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5" data-testid="pg-status-strip">
      {CARDS.map((c) => {
        const v = metrics[c.key] ?? 0;
        const hot = v > 0 && c.tone;
        return (
          <button key={c.key} onClick={() => onPick(c)} data-testid={`pg-metric-${c.key}`}
            className={cn("rounded-xl border border-line bg-card p-3 text-left transition-colors hover:border-copper/40", hot === "danger" && "border-danger/30 bg-danger-bg", hot === "warning" && "border-warning/30 bg-warning-bg")}>
            <div className="text-xs text-ink-2">{c.label}</div>
            <div className="mt-1 font-display text-2xl font-semibold text-ink">{v}{c.suffix && <span className="ml-1 text-sm font-normal text-ink-muted">{c.suffix}</span>}</div>
          </button>
        );
      })}
    </div>
  );
}
